// Re-render Shop Pay / accelerated checkout button when variant changes
document.addEventListener('variantUpdate', () => {
  if (window.Shopify && Shopify.PaymentButton) {
    Shopify.PaymentButton.render();
  }
});
